import React from 'react';
import { Link } from 'react-router-dom';
import SupplierSectionHeading from './SupplierSectionHeading';

type Breadcrumb = { label: string; to?: string };

type SupplierPageLayoutProps = {
  title: string;
  subtitle?: string;
  icon?: string;
  breadcrumbs?: Breadcrumb[];
  toolbar?: React.ReactNode;
  children: React.ReactNode;
  wide?: boolean;
};

const SupplierPageLayout: React.FC<SupplierPageLayoutProps> = ({
  title,
  subtitle,
  icon,
  breadcrumbs,
  toolbar,
  children,
  wide,
}) => (
  <div className={`sp-page${wide ? ' sp-page--wide' : ''}`}>
    {breadcrumbs && breadcrumbs.length > 0 && (
      <nav className="sp-breadcrumb" aria-label="Breadcrumb">
        <ol>
          {breadcrumbs.map((crumb, index) => (
            <li key={`${crumb.label}-${index}`}>
              {crumb.to ? <Link to={crumb.to}>{crumb.label}</Link> : <span>{crumb.label}</span>}
            </li>
          ))}
        </ol>
      </nav>
    )}
    <section className="sp-card">
      <header className="sp-card__header">
        <SupplierSectionHeading title={title} subtitle={subtitle} icon={icon} />
      </header>
      {toolbar && <div className="sp-card__toolbar">{toolbar}</div>}
      <div className="sp-card__body">{children}</div>
    </section>
  </div>
);

export default SupplierPageLayout;
